<template>
  <div>
    <div class="d-flex justify-content-end">
      <b-dropdown v-if="pagination && pagination.docs.length" split split-href="#" :text="$t('task.download-options')" size="sm" variant="light" class="mr-2 ">
        <b-dropdown-item @click="downloadExcel" href="#">{{ $t("common.download") }}</b-dropdown-item>
      </b-dropdown>
      <!-- 
      <a v-b-modal="'import-thirdparty'" href="javascript:;">
        {{ $t("thirdparty.import-thirdparty.text") }}
      </a>
-->
      <right-panel class="float-right" id="sidebar-new-thirdparty" width="600px" :icon="'mdi mdi-plus'" @hidden="rightPanelClosed">
        <div class="pl-5 pr-5">
          <Form />
        </div>
      </right-panel>

      <sweet-button class="mr-4" v-b-modal="'sidebar-new-thirdparty'" @click="toggleForm" variant="link" icon="bx bx-plus" size="sm" buttonClass=" text-white btn-main">
        {{ $t("thirdparty.new") }}
      </sweet-button>

      <sweet-button v-b-modal="'import-thirdparty'" href="javascript:;" variant="link" icon="bx bx-plus" size="sm" buttonClass=" text-white btn-main">
        {{ $t("thirdparty.import-thirdparty.text") }}
      </sweet-button>
    </div>
    <modal id="import-thirdparty" :title="$t('thirdparty.import-thirdparty.text')"> <OrganizationthirdPartyImport :organization="currentOrganization" @onSent="paginate()"/></modal>
    <h2>{{ $t("thirdparty.plural") }}</h2>

    <table class="table project-list-table compact ">
      <thead>
        <tr>
          <th style="width:80px"></th>
          <th style="width:300px">
            <sortable-table-head field="name" :text="$t('thirdparty.text')" tag="span" :request="request" />
          </th>
          <th style="width:300px">{{ $t("receiver-group.text") }}</th>
          <th style="width:300px">{{ $t("country.name") }}</th>
          <th style="width:300px">{{ $t("agreement-type.text") }}</th>
          <th style="width:300px">{{ $t("thirdparty.software-provider") }}</th>
          <th style="width:300px">{{ $t("thirdparty.direction") }}</th>
          <th style="width: 15%">
            <a href="javascript:;" @click="toggleFilter">
              <span v-if="filterEnabled" class="text-warning">
                <i class="bx bxs-filter-alt"></i>
                {{ $t("common.filters-hide") }}
              </span>
              <span v-else class="text-muted">
                <i class="bx bxs-filter-alt"></i>
                {{ $t("common.filters-show") }}
              </span>
            </a>
          </th>
        </tr>
        <tr v-if="filterEnabled">
          <th></th>
          <th><input class="form-control " v-model="nameFilter" :placeholder="$t('common.search')" /></th>

          <th>
            <filter-select
              id="receiverGroupFilter"
              ref="receiverGroupFilter"
              :placeholder="$t('receiver-group.text')"
              :multiple="false"
              @filter="onReceiverGroupSearch"
              @changed="onReceiverGroupSelect"
            />
          </th>

          <th>
            <filter-select
              id="countryFilter"
              ref="countryFilter"
              :placeholder="$t('country.select')"
              :multiple="false"
              @filter="onCountrySearch"
              @changed="onCountrySelect"
              track="code"
            />
          </th>

          <th>
            <filter-select
              id="agreementTypeFilter"
              ref="agreementTypeFilter"
              :placeholder="$t('agreement-type.text')"
              :multiple="false"
              @filter="onAgreementTypeSearch"
              @changed="onAgreementTypeSelect"
            />
          </th>

          <th colspan="4"></th>
        </tr>
      </thead>
      <template v-if="pagination && pagination.docs.length > 0">
        <tr v-for="item in pagination.docs" :key="item._id" class="hider">
          <td>
            <div class="hidden hand">
              <a @click="edit(item)" v-b-toggle="'sidebar-edit-organization-datasource'" v-b-tooltip.hover :title="$t('common.edit')" class="mr-2">
                <i class="bx bx-pencil text-primary"></i>
              </a>

              <a @click="deleteById(item)" v-b-tooltip.hover :title="$t('common.delete')">
                <i class="bx bx-trash-alt text-danger"></i>
              </a>
            </div>
          </td>

          <td>
            {{ item.name | translate }}
          </td>

          <td>
            {{ item.receiverGroup.name | translate }}
          </td>

          <td>
            {{ item.country.name | translate }}
          </td>

          <td>
            <span v-if="item.agreementType">{{ item.agreementType.name | translate }}</span>
          </td>

          <td>
            {{ item.softwareProvider ? $t("common.yes") : $t("common.no") }}
          </td>

          <td>
            <span v-if="item.direction == 'NONE'">{{ $t("thirdparty.none") }}</span>
            <span v-if="item.direction == 'EXPORT'">{{ $t("thirdparty.export") }}</span>
            <span v-if="item.direction == 'IMPORT'">{{ $t("thirdparty.import") }}</span>
            <span v-if="item.direction == 'BOTH'">{{ $t("thirdparty.both") }}</span>
          </td>

          <td colspan="2"></td>
        </tr>
      </template>
    </table>
    <!-- end row -->

    <content-loading v-if="isLoading" />

    <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)">
      <h5 class="text-center">
        {{ $t("data.no-data") }}
      </h5>
    </empty>

    <!-- Begin: Pagination -->

    <div v-if="pagination" class="row mb-5 pb-5">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <div class="mb-5 mt-5 pt-5 pb-5"></div>
    <!-- End: Pagination -->
  </div>
</template>

<script>
import Modal from "@c/modal.vue";
import Countries from "../countries/countries.json";
import Form from "./organization-thirdparty-form";
import OrganizationthirdPartyImport from "./organization-thirdparty-import";

export default {
  components: { Form, OrganizationthirdPartyImport, Modal },
  data() {
    return {
      request: {
        options: { page: 1, limit: 15, sort: { name: "asc" } },
        query: {},
      },

      nameFilter: undefined,
      filterEnabled: false,
    };
  },
  computed: {
    selectedEntity() {
      return this.$store.getters["organizationThirdParty/selectedEntity"];
    },
    pagination() {
      return this.$store.getters["organizationThirdParty/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationThirdParty/isLoading"];
    },
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },

    nameFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
  },
  mounted() {},
  methods: {
    toggleForm() {
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-thirdparty");
    },
    async paginate() {
      await this.$store.dispatch("organizationThirdParty/paginate", this.request);
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationThirdParty/delete", item._id);
        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' Silindi");
        this.paginate();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: "'" + this.$options.filters.translate(item.name) + "' Silinemedi" });
      }
    },

    edit(item) {
      this.$store.commit("organizationThirdParty/editedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-thirdparty");
    },

    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;

      if (!this.filterEnabled) {
        this.request = {
          options: { page: 1, limit: 15, sort: { name: "asc" } },
          query: {},
        };
        this.nameFilter = undefined;
      }
    },

    rightPanelClosed() {
      this.paginate();
      this.$store.dispatch("organizationThirdParty/resetForm");
    },

    async onReceiverGroupSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationReceiverGroup/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onReceiverGroupSelect(item) {
      if (item && Object.keys(item).length) {
        this.request.query = {
          ...this.request.query,
          receiverGroup: { value: item._id, isObject: true },
        };
      } else {
        this.request.query["receiverGroup"] = null;
        delete this.request.query["receiverGroup"];
      }
    },

    async onAgreementTypeSearch(value, callback) {
      const response = await this.$store.dispatch(`agreementType/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onAgreementTypeSelect(item) {
      if (item && Object.keys(item).length) {
        this.request.query = {
          ...this.request.query,
          "agreementType._id": { value: item._id, isObject: true },
        };
      } else {
        this.request.query["agreementType._id"] = null;
        delete this.request.query["agreementType._id"];
      }
    },

    async onCountrySearch(value, callback) {
      const lang = "tr";
      const response = Countries.filter((x) => x.name[lang].toLowerCase().includes(value.toLowerCase()));
      callback(response);
    },
    onCountrySelect(item) {
      if (item && Object.keys(item).length) {
        this.request.query = {
          ...this.request.query,
          "country.code": { value: item.code, isObject: true },
        };
      } else {
        this.request.query["country.code"] = null;
        delete this.request.query["country.code"];
      }
    },

    //
    async download(item) {
      this.$store.commit("fileManager/addDownloadedFile", { file: item });
    },

    async downloadExcel() {
      // const ok = await this.confirm(this.$t("alert.approve"));
      // if (!ok) {
      //   return;
      // }
      try {
        const { data: file } = await this.$store.dispatch(`organizationThirdParty/download`);
        this.download(file);

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        console.error(error);
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
